import type { Funnel } from "../api/review";

export const ALL_STEPS = "all";

/** Reached counts per step; click a step to list the candidates whose furthest step it is. */
export function FunnelBar({
  funnel,
  selected,
  onSelect,
}: {
  funnel: Funnel;
  selected: string;
  onSelect: (step: string) => void;
}) {
  const top = Math.max(funnel.total, 1);
  return (
    <section className="funnel" aria-label="Funnel">
      <ol>
        {funnel.steps.map((s, i) => {
          // Drop-off against the last step everyone must pass; optional steps get none.
          const base = s.optional
            ? undefined
            : funnel.steps
                .slice(0, i)
                .filter((p) => !p.optional)
                .at(-1)?.reached;
          const drop = base ? Math.round(((base - s.reached) / base) * 100) : null;
          return (
            <li key={s.step}>
              <button
                type="button"
                className={`funnel-step${selected === s.step ? " selected" : ""}`}
                aria-pressed={selected === s.step}
                onClick={() => onSelect(s.step)}
              >
                <span className="funnel-label">
                  {s.label}
                  {s.optional && <span className="muted"> (optional)</span>}
                </span>
                <span className="funnel-bar" aria-hidden="true">
                  <span style={{ width: `${(s.reached / top) * 100}%` }} />
                </span>
                <span className="funnel-numbers">
                  <strong>{s.reached}</strong> reached
                  {drop !== null && drop > 0 && <span className="muted"> · −{drop}%</span>}
                  <span className="muted"> · {s.current} here now</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
      <p className="muted">
        {funnel.total} applications. Agents connected via OAuth {funnel.via.oauth ?? 0}, token{" "}
        {funnel.via.token ?? 0}
        {(funnel.via.unknown ?? 0) > 0 && `, unknown ${funnel.via.unknown}`}. "Here now" = furthest
        step; click a step to list those candidates.{" "}
        <button
          type="button"
          className={`link-button${selected === ALL_STEPS ? " selected" : ""}`}
          onClick={() => onSelect(ALL_STEPS)}
        >
          Show everyone
        </button>
      </p>
    </section>
  );
}
